import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SKIP_AUTH } from 'src/app/constants/ContextToken';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EvlService {

  private readonly apiBase = environment.apiUrl;

  constructor(private http: HttpClient) { }

  submitEvaluation(userEvaluation: any): Observable<any> {
    return this.http.post(`${this.apiBase}/user/evaluation/submit`, userEvaluation, {
      context: new HttpContext().set(SKIP_AUTH, true)
    })
  }

  getSubjectEvaluationCriteria(id: number): Observable<any> {
    return this.http.get(`${this.apiBase}/public/subject/evaluation/criteria/get-subject-by-id?id=${id}`);
  }

  //------------------------------Evaluation------------------------------
  GetEvaluationsList(): Observable<any> {
    return this.http.get<any>(`${this.apiBase}/evaluation/subject/get-all`);
  }

  getEvaluationSubject(id: number): Observable<any> {
    return this.http.get(`${this.apiBase}/public/evaluation/subject/get-by-id?id=${id}`);
  }

  //-------------------------------------
  // Fetch data dynamically based on selected table
  getTableData(endpoint: string, TypeId: number): Observable<any> {
    return this.http.get<any>(`${this.apiBase}/public/${endpoint}/get-by-type-id?typeId=${TypeId}`);
  }

  generateQr(url: string): Observable<any> {
    return this.http.get(`${this.apiBase}/qRCode/generate?url=${url}`, {
      responseType: 'blob'
    });
  }

  saveQrImage(imgBase64: string): Observable<any> {
    // Wrap imgBase64 in an object to send it as JSON
    const formData = { imgBase64: imgBase64 };

    return this.http.post(`${this.apiBase}/qRCode/saveQR`, formData, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  getObjName(id: number, tableName: string): Observable<any> {
    return this.http.post(`${this.apiBase}/evaluationSubject/get-objectName`, [id, tableName]);
  }

  getByIdAndStatus(controllerRoute: string, id: number, status: boolean): Observable<any> {
    return this.http.get<any>(`${this.apiBase}/${controllerRoute}/get-subject-by-id-and-status?id=${id}&status=${status}`);
  }
}